import {Component, OnInit} from '@angular/core';
import {CommonService} from "../../core/services/common.service";
import {AffiliateService} from "../../core/services/affiliate.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  userCode:any;
   customer: any;
  constructor(private affiliateService: AffiliateService,private common:CommonService) {
    this.customer = this.common.getStorage('customer');
    this.userCode=this.customer.firstName.charAt(0).toUpperCase()+this.customer.lastName.charAt(0).toUpperCase();
  }
  affiliateLink = 'https://smartdukaan.com/affiliate/aman-gupta-ss042';
  copied = false;
  currentView = 'dashboard';
  featuredProduct: any;

  // Stats data
  stats = [
    { title: 'Total Earnings', value: '₹0.00', icon: 'wallet', color: 'danger' },
    { title: 'Active Links', value: '0', icon: 'link', color: 'primary' },
    { title: 'Successful Sales', value: '0', icon: 'cart', color: 'success' },
    { title: 'Total Referral', value: '0', icon: 'trophy', color: 'warning' }
  ];

  // Trending products
  trendingProducts = [
    {
      name: 'Samsung Galaxy S25 Ultra',
      description: '12GB RAM, 256GB Storage',
      price: '₹1,24,999',
      commission: '₹1,250'
    },
    {
      name: 'iPhone 16 Pro Max',
      description: '6GB RAM, 128GB Storage',
      price: '₹1,39,900',
      commission: '₹1,399'
    },
    {
      name: 'OnePlus 13 5G',
      description: '16GB RAM, 256GB Storage',
      price: '₹61,999',
      commission: '₹620'
    },
    {
      name: 'Xiaomi 15 Pro',
      description: '8GB RAM, 256GB Storage',
      price: '₹62,999',
      commission: '₹630'
    }
  ];

  // Performance metrics
  performanceMetrics = [
    { title: 'Link Clicks', value: '1,248', icon: 'mouse', color: 'primary' },
    { title: 'Growth Rate', value: '+12.4%', icon: 'graph-up-arrow', color: 'warning' },
    { title: 'Avg. Sale Value', value: '₹890', icon: 'currency-rupee', color: 'success' },
    { title: 'Conversion Rate', value: '4.8%', icon: 'percent', color: 'info' },

  ];

  // Leaderboard
  leaderboard = [
    { rank: 1, name: 'Priya Patel', type: 'SmartInfluencer', id: 'SI-012', earnings: '₹34,200' },
    { rank: 2, name: 'Rajiv Mehta', type: 'SmartSeller', id: 'SS-105', earnings: '₹28,700' },
    { rank: 3, name: 'Ananya Sharma', type: 'SmartInfluencer', id: 'SI-045', earnings: '₹25,400' },
    { rank: 24, name: 'Ravi Sharma', type: 'SmartSeller', id: 'SS-042', earnings: '₹4,500' }
  ];

  // Training materials
  trainingMaterials = [
    { title: 'How to create effective links', duration: '5 min video', icon: 'play-circle', color: 'danger' },
    { title: 'WhatsApp marketing strategies', duration: '8 min video', icon: 'play-circle', color: 'primary' },
    { title: 'Converting browsers to buyers', duration: '6 min video', icon: 'play-circle', color: 'success' }
  ];

  ngOnInit() {
    this.getStatistics();
    this.getFeaturedProduct();
  }

  // Copy affiliate link to clipboard
  copyLink() {
    navigator.clipboard.writeText(this.affiliateLink).then(() => {
      this.copied = true;
      setTimeout(() => this.copied = false, 2000);
    });
  }

  getStatistics() {
    this.affiliateService.getStatistics(this.customer.id).subscribe({
      next: (res) => {
        this.stats[1].value = res.response.affiliateLinks?.length || 0;
        this.stats[0].value = '₹'+(res.response.affiliateEarnings.reduce((sum, r) => sum + (r.amount ?? 0), 0)).toFixed(2);
        this.stats[2].value = res.response.affiliateOrders?.length || 0;
      },
      error: (err) => {
        console.error("Error loading stats", err);
      }
    });
  };
  public getFeaturedProduct(): void {
    this.affiliateService.featuredProduct().subscribe({
      next: (res) => {
        this.featuredProduct = res.response.CatalogResponse;
        console.log("getting featured Product ", this.featuredProduct)
      },
      error: (err) => {
        console.error("Error loading stats", err);
      }
    });
  };
}
